var G = require('@antv/g/lib');

module.exports = G;


//////////////////
// WEBPACK FOOTER
// ./src/renderer.js
// module id = 16
// module chunks = 0 1 2